import {on} from '@/libs/tools'
export default {
  inserted: (el,binding,vnode)=>{
    let triggerDom = document.getElementById(binding.value.trigger)

    let bodyDom = document.getElementById(binding.value.body)
    let pageX = 0
    let pageY = 0
    let transformX = 0
    let transformY = 0
    let canMove = false

    let top = binding.value.top
    let left = binding.value.left
    let width = binding.value.width
    let height = binding.value.height

    const handleMousedown = e => {
      if (!binding.value.canMove){
        return
      }
      triggerDom.style.cursor = 'move'
      let transform = /\(.*\)/.exec(bodyDom.style.transform)
      if (transform) {
        transform = transform[0].slice(1, transform[0].length - 1)
        let splitxy = transform.split('px, ')
        transformX = parseFloat(splitxy[0])
        transformY = parseFloat(splitxy[1].split('px')[0])
      }
      pageX = e.pageX
      pageY = e.pageY
      canMove = true
      if (binding.value.start){
        binding.value.start(e)
      }
    }

    const handleMousemove = e => {
      let x = Math.min(Math.max(left,e.pageX),width)
      let y = Math.min(Math.max(top,e.pageY),height)


      let xOffset = x- pageX + transformX
      let yOffset = y - pageY + transformY

      if (canMove){
        bodyDom.style.transform = `translate(${xOffset}px,${yOffset}px)`
        if (binding.value.move){
          binding.value.move(e)
        }
      }
    }

    const handleMouseup = e => {
      triggerDom.style.cursor = 'default'
      canMove = false
      if (binding.value.end){
        binding.value.end(e)
      }
    }

    on(triggerDom,'mousedown',handleMousedown)
    on(document,'mousemove',handleMousemove)
    on(triggerDom,'mouseup',handleMouseup)
  },
  binding(el,binding,vNode){
  },
  update: (el,binding,vnode) => {
    if (!binding.value.recover) return
    let bodyDom = document.getElementById(binding.value.body)
    bodyDom.style.transform = ''
  }
}



// WEBPACK FOOTER //
// ./src/directive/module/draggable.js